import R from '../lib/routes';

const initialArticleState = {
  items: [],
  page: 1,
};

export const articlesState = {
  [R.news]: {
    ...initialArticleState,
  },
  [R.blog]: {
    ...initialArticleState,
  },
  [R.knowledgeBase]: {
    ...initialArticleState,
  },
};

export const updatePageArticles = (prop, payload) => {
  const { articles, page } = payload;
  articlesState[prop].items[parseInt(page - 1)] = [...articles];
};

export const incrementArticlesPage = prop => {
  articlesState[prop].page += 1;
};

export const resetArticlesPage = prop => {
  articlesState[prop] = { ...initialArticleState };
};
